import { Nilable } from "../shared/utils/Nullable";

export interface IPaisDTO {
    id: number;
    name: string;
    code: string;
}

export class PaisDTO {
    public id = 0;
    public nombre = "";
    public codigo = "";

    constructor(json: Nilable<Partial<IPaisDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IPaisDTO>) {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.name != null) {
            this.nombre = json.name;
        }
        if (json.code != null) {
            this.codigo = json.code;
        }
    }

    public toJSON(): IPaisDTO {
        return {
            id: this.id,
            name: this.nombre,
            code: this.codigo
        };
    }
}
